import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-email\"><defs><style></style></defs><path d=\"M853.995 341.995V256L512 469.995 170.005 256v85.995L512 554.005zm0-171.99q34.005 0 59.008 26.006t25.002 60.01v512q0 34.006-25.002 60.011t-59.008 26.005H169.984q-34.005 0-59.008-26.005t-25.003-60.01v-512q0-34.006 25.003-60.011t59.008-26.006h684.01z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol